export const SET_ORGANISATION_USERS = 'user/SET_ORGANISATION_USERS';
export const SET_ORGANISATION_CLIENTS = 'user/SET_ORGANISATION_CLIENTS';
export const SET_ROLES = 'user/SET_ROLES';
export const SET_PAGINATION_META = 'user/SET_PAGINATION_META';
export const SET_CLIENT_PAGINATION_META = 'user/SET_CLIENT_PAGINATION_META';
export const SET_APPLIED_USER_FILTER = 'user/SET_APPLIED_USER_FILTER';
